<div class="congtainer">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
            <h1>CLUB DE KARATE DO TIGRE ROJO</h1>
        </div>
    </div>
</div>
<div class="congtainer">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
           <p>En el año 1995 se creo el club de KARATE - DO "HALCON", con un grupo de amigos quienes empezaron a entrenar este milenario arte marcial
               especificamente el estilo SHOTOKAN, creado por el Sensei GICHIN FUNAKOSHI padre del KARATE moderno, despues de un par de años de entrenamientos 
               el grupo de amigos decide formalizar el club de KARATE registrando el nombre CLUB DE KARATE DO - HALCON a nivel nacional por medio de la concentración deportiva de Pichincha.

           </p>
           <p>
               El club de KARATE DO - HALCON hasta el año 2010 funciono con dicho nombre, debido a nuevas reformas legales en Ecuador los clubs deportivos tenian el derecho de cambiar su nombre, 
               mediante una asamblea con los miembros del CLUB HALCON se decidieron cambiar de nombre por el que en la actualidad posee, denominado <strong>CLUB DE KARATE - DO FORMATIVO ESPECIALIZADO TIGRE ROJO.</strong>
           </p>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
            <h2>SIGNIFICADO CLUB TIGRE ROJO</h2>
            <p><strong>Tigre: </strong>simboliza estado de alerta, serenidad, fuerza, valor y coraje.</p>
            <p><strong>Rojo: </strong>simboliza el sol naciente y el amor en la cultura Japonesa.</p>
            <p>Juntando estos significados podemos decir que TIGRE ROJO se lo podría interpretar como Tigre Del Sol Naciente.</p>
        </div>
        <div class="col-sm" style="text-align: center;">
            <img src="../../../assets/img/karate/TIGREROJO_INICIO.jpg" style="margin-left: 0;" alt="CLUB_TIGRE_ROJO">
        </div>
        <div class="col-sm" style="text-align: center;">
            <h2>ESTILO SHOTOKAN</h2>
            <p>El estilo que se practica en el CLUB DE KARATE - DO TIGRE ROJO es el SHOTOKAN</p>
            <p>Este es un de los estilos más practicados a nivel mundial dentro de las artes marciales siendo una de las más fuertes disciplinas, 
                las cuales trabajan la mente y el espiritu (Concentración mental).
            </p>
        </div>
    </div>
</div>